import React from 'react'
import { Box, Typography, Tag } from '@octanner/prism-core'
import { DateTime } from 'luxon'
import { ScheduledTask } from '../../hooks/useGetCelebrationByIdentity'
import { getStatusProps, Status, StatusLabel } from './utils'

type Props = {
  scheduledTask: ScheduledTask & { status: Status }
  taskIndex: number
  timelineIndex: number
}

// Helper function to format sentenceCase action types.

const formatDateStringWithTime = (dateStr: string): string => {
  return DateTime.fromISO(dateStr, { zone: 'local' }).toFormat(
    'dd LLL yyyy | hh:mm a'
  )
}

const getScheduledTaskLabel = (actionType: string) => {
  switch (actionType) {
    case 'CC_TASK':
      return 'Task:'
    case 'EMAIL':
      return 'Email:'
    case 'SYSTEM_TASK':
    default:
      return null
  }
}

const ScheduledTaskSummary: React.FC<Props> = ({
  scheduledTask,
  timelineIndex,
  taskIndex,
}) => {
  const status = scheduledTask.status
  const statusProps = getStatusProps(status)
  const tagVariant = statusProps.tagVariant ?? undefined

  const label = getScheduledTaskLabel(scheduledTask.actionType)

  return (
    <Box sx={{ width: '269px' }}>
      {label && (
        <Typography variant="h4" mb={'8px'}>
          {label}
        </Typography>
      )}
      <Tag
        variant={tagVariant}
        data-testid={`timeline-status-tag-${timelineIndex}-${taskIndex}`}
      >
        {StatusLabel[scheduledTask.status]}
      </Tag>
      {(scheduledTask.status === Status.Completed ||
        scheduledTask.status === Status.Failed) && (
        <Typography
          variant="caption"
          color="textSecondary"
          data-testid={`timeline-completion-date-${timelineIndex}-${taskIndex}`}
          sx={{
            p: '2px 8px',
          }}
        >
          {formatDateStringWithTime(
            scheduledTask.lastExecution?.executionTime
              ? scheduledTask.lastExecution.executionTime
              : scheduledTask.cancelledTime ?? ''
          )}
        </Typography>
      )}
    </Box>
  )
}

export default ScheduledTaskSummary
